import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { TimerBar } from './components/TimerBar';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { TopTestimonials } from './components/TopTestimonials';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { ForYouSection } from './components/ForYouSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueTable } from './components/ValueTable';
import { PricingSection } from './components/PricingSection';
import { BottomTestimonials } from './components/BottomTestimonials';
import { ComparisonSection } from './components/ComparisonSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-ink-950 font-sans text-white" data-id="element-0" data-mp="3mjq1tehaqquj">
      <noscript data-id="element-1" data-mp="3rdaselgk8ijp">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3rcsw5otwe4bs" />
      </noscript>
      <TimerBar data-id="element-3" data-mp="2zn678kkz7rhf" />
      <Hero data-id="element-4" data-mp="33morde4z3yj7" />
      <TrustStrip data-id="element-5" data-mp="33m5a7zn5de68" />
      <main data-id="element-6" data-mp="33nq4rp9gox43">
        <TopTestimonials data-id="element-7" data-mp="33ngiabnml835" />
        <PainSection data-id="element-8" data-mp="33ork45xig5rm" />
        <SolutionSection data-id="element-9" data-mp="38m1fs3bhtdnw" />
        <VolumesSection data-id="element-10" data-mp="38li619vzxvky" />
        <ForYouSection data-id="element-11" data-mp="38k6w0sbyjrle" />
        <BonusesSection data-id="element-12" data-mp="38o4h3ji3it7x" />
        <ValueTable data-id="element-13" data-mp="3dkl0y1i9ilf7" />
        <PricingSection data-id="element-14" data-mp="3dlw6a5rcw18f" />
        <BottomTestimonials data-id="element-15" data-mp="3dmfmni1cyhkc" />
        <ComparisonSection data-id="element-16" data-mp="nvj4bi5joiqs" />
        <GuaranteeSection data-id="element-17" data-mp="nwc2huqftzxb" />
        <FaqSection data-id="element-18" data-mp="nuraabrlit2m" />
        <FinalCta data-id="element-19" data-mp="nxn6nvnsp9oy" />
      </main>
      <SiteFooter data-id="element-20" data-mp="sudmqizlo5ad" />
    </div>;
}